import React, { useEffect, useRef, useState } from "react";
import "./About.css";

import AOS from "aos";
import "aos/dist/aos.css";

import about1 from "../assets/about1.jpg";
import about2 from "../assets/about2.jpg";

// ✅ CENTER IMAGE
import planImg from "../assets/plan.png";

import favIconIbs from "../assets/favicon-ibs.png";

// ✅ key image
import keyImg from "../assets/key.png";

export default function About() {
  useEffect(() => {
    AOS.init({
      duration: 850,
      easing: "ease-out-cubic",
      once: true,
      offset: 110,
    });
  }, []);

  return (
    <section className="aboutPage">
      {/* ===== SECTION 1 ===== */}
      <div className="aboutSectionOne">
        <div className="aboutInner" data-aos="fade-up">
          <h1 className="aboutTitle">About Us</h1>
          <div className="aboutAccent" aria-hidden="true" />
          <p className="aboutText">
            Our values and discipline vaulted us to the top of our industry.
          </p>
        </div>
      </div>

      {/* ===== SECTION 2 ===== */}
      <div className="aboutSectionTwo">
        <div className="aboutInner">
          {/* Who We Are */}
          <div className="gridCard">
            <div className="gridTwo">
              <div className="infoCard infoCardStack" data-aos="fade-right">
                <h2 className="cardTitle">Who We Are?</h2>
                <p className="cardText">
                  IBSPL is a construction and project development firm delivering
                  high-quality residential, commercial, and infrastructure
                  projects. With strong execution and industry experience, we
                  manage projects from concept to completion ensuring timely
                  delivery, quality workmanship, and cost-effective results.
                  <br />
                  <br />
                  We focus on building durable, functional, and sustainable
                  spaces through efficient project management, skilled
                  construction practices, and close collaboration with clients
                  and stakeholders, while upholding the highest standards of
                  safety and quality.
                </p>
              </div>

              <div className="mediaCard" data-aos="fade-left">
                <div className="imageFrame">
                  <img
                    className="cardImg"
                    src={about1}
                    alt="Construction planning and design"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Why Choose IBS */}
          <div className="gridCard">
            <div className="gridTwo reverse">
              <div className="mediaCard" data-aos="fade-right">
                <div className="imageFrame tall">
                  <img
                    className="cardImg"
                    src={about2}
                    alt="Construction site work"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="infoCard infoCardStack" data-aos="fade-left">
                <h2 className="cardTitle">Why Choose IBS?</h2>
                <ul className="chooseList">
                  <li>
                    Expert execution with uncompromising quality and attention to
                    detail.
                  </li>
                  <li>
                    Forward-thinking construction aligned with sustainability
                    and long-term value.
                  </li>
                  <li>
                    Efficient, end-to-end management ensuring timely and
                    cost-effective completion.
                  </li>
                  <li>
                    Collaborative, transparent, and committed to excellence at
                    every stage.
                  </li>
                  <li>A trusted partner committed to your growth and success</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ STATS SECTION */}
      <StatsSection />

      {/* ===== HOW IT WORKS ===== */}
      <section className="section howItWorksSection">
        <div className="container">
          {/* Header */}
          <div className="howItWorksHeader" data-aos="fade-up">
            <div className="howLogoWrap">
              <img
                src={favIconIbs}
                alt="IBS logo"
                className="howLogo"
                loading="lazy"
              />
            </div>
            <p className="howKicker">PLAN + CONTROL</p>
            <h2 className="howTitle">How it Works</h2>
          </div>

          {/* Flow */}
          <div className="howItWorksFlow">
            <div className="howStepsCol">
              <div data-aos="fade-right" data-aos-delay="0">
                <HowStep
                  num="1"
                  title="Phase Plan"
                  text="This step connects the design process and its milestones with construction."
                />
              </div>
              <div data-aos="fade-right" data-aos-delay="120">
                <HowStep
                  num="2"
                  title="Design Pull Plan"
                  text="We work with the design team to establish a detailed plan for reaching our goals."
                />
              </div>
            </div>

            <div
              className="howCenterMedia"
              data-aos="zoom-in"
              data-aos-delay="80"
            >
              <div className="howPlanFrame">
                <img
                  src={planImg}
                  alt="Planning process"
                  className="howPlanImage"
                  loading="lazy"
                />
                <div className="howPlanOverlay" aria-hidden="true" />
              </div>
            </div>

            <div className="howStepsCol">
              <div data-aos="fade-left" data-aos-delay="0">
                <HowStep
                  num="3"
                  title="Coordinated Layout"
                  text="This process creates a single point of truth: coordinated drawings for the whole project."
                />
              </div>
              <div data-aos="fade-left" data-aos-delay="120">
                <HowStep
                  num="4"
                  title="Quality Control"
                  text="Having geometry worked out in the Coordinated Layout step, prior to construction."
                />
              </div>
            </div>
          </div>

          {/* ===== KEY BENEFITS ===== */}
          <div className="keyBenefitsWrap">
            <div className="keyBenefitsGrid">
              <div className="dimensionCard" data-aos="fade-right">
                <div className="dimensionGlow" aria-hidden="true" />
                <div className="dimensionInner dimensionInnerImage">
                  <img
                    src={keyImg}
                    alt="Key"
                    className="dimensionKeyImg"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="keyBenefitsContent" data-aos="fade-left">
                <h3 className="keyBenefitsTitle">Key Benefits</h3>

                <p className="keyBenefitsIntro">
                  A practical approach to planning and control that reduces
                  waste, improves coordination, and speeds up delivery.
                </p>

                <ul className="keyBenefitsList">
                  <li data-aos="fade-up" data-aos-delay="0">
                    <span className="kbDot" aria-hidden="true" />
                    <span className="kbText">
                      Labor expenses are a common target for cost reduction
                      measures in the construction industry.
                    </span>
                  </li>

                  <li data-aos="fade-up" data-aos-delay="80">
                    <span className="kbDot" aria-hidden="true" />
                    <span className="kbText">
                      A good material management system includes proper
                      communication, scheduling, and tracking tools.
                    </span>
                  </li>

                  <li data-aos="fade-up" data-aos-delay="160">
                    <span className="kbDot" aria-hidden="true" />
                    <span className="kbText">
                      Faster supplies can be used upon delivery to a
                      construction site, the better.
                    </span>
                  </li>

                  <li data-aos="fade-up" data-aos-delay="240">
                    <span className="kbDot" aria-hidden="true" />
                    <span className="kbText">
                      Effective material management systems ensure materials are
                      in the right place at the right time.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* ✅ partnerBannerWrap REMOVED ✅ */}
        </div>
      </section>
    </section>
  );
}

/* =========================================================
   ✅ STATS SECTION (COUNTING)
   ========================================================= */
function StatsSection() {
  const wrapRef = useRef(null);
  const [startCount, setStartCount] = useState(false);
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const reduce =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    setReduceMotion(!!reduce);

    if (reduce) {
      setStartCount(true);
      return;
    }

    const el = wrapRef.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setStartCount(true);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        const ent = entries[0];
        if (ent && ent.isIntersecting) {
          setStartCount(true);
          io.disconnect();
        }
      },
      { threshold: 0.35 }
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section className="section ibsStatsSection" ref={wrapRef}>
      <div className="container">
        <div className="ibsStatsGrid">
          <div data-aos="zoom-in" data-aos-delay="0">
            <CountStatsCard
              end={10}
              suffix="+"
              label="YEARS"
              sub="Professional Experience"
              start={startCount}
              reduceMotion={reduceMotion}
            />
          </div>

          <div data-aos="zoom-in" data-aos-delay="120">
            <CountStatsCard
              end={20}
              suffix="+"
              label="PEOPLE"
              sub="Employees in team"
              center
              start={startCount}
              reduceMotion={reduceMotion}
            />
          </div>

          <div data-aos="zoom-in" data-aos-delay="240">
            <CountStatsCard
              end={10}
              suffix="+"
              label="LOCATIONS"
              sub="Sites in development"
              start={startCount}
              reduceMotion={reduceMotion}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function CountStatsCard({
  end,
  suffix = "",
  label,
  sub,
  center,
  start,
  reduceMotion,
}) {
  const value = useCountUp({
    end,
    start,
    durationMs: 1800,
    reduceMotion,
  });

  return (
    <article className={`ibsStatNeo ${center ? "ibsStatNeoCenter" : ""}`}>
      <div className="ibsStatNeoTop" aria-hidden="true" />
      <div className="ibsStatNeoCorner" aria-hidden="true" />
      <div className="ibsStatNeoGrid">
        <div className="ibsStatNeoNum">
          {value}
          {suffix}
        </div>
        <div className="ibsStatNeoRight">
          <div className="ibsStatNeoChip">{label}</div>
          <p className="ibsStatNeoSub">{sub}</p>
        </div>
      </div>
    </article>
  );
}

function useCountUp({ end, start, durationMs = 1800, reduceMotion = false }) {
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!start) return;

    if (reduceMotion) {
      setVal(end);
      return;
    }

    let raf = null;
    const from = 0;
    const startTime = performance.now();

    const tick = (now) => {
      const t = Math.min(1, (now - startTime) / durationMs);
      const eased = 1 - Math.pow(1 - t, 5);
      const next = Math.round(from + (end - from) * eased);
      setVal(next);
      if (t < 1) raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => {
      if (raf) cancelAnimationFrame(raf);
    };
  }, [end, start, durationMs, reduceMotion]);

  return val;
}

function HowStep({ num, title, text }) {
  return (
    <article className="howStepCard">
      <div className="howStepTop">
        <div className="howStepNum" aria-hidden="true">
          {num}
        </div>
        <div className="howStepAccent" aria-hidden="true" />
      </div>

      <h3 className="howStepTitle">{title}</h3>
      <p className="howStepText">{text}</p>
    </article>
  );
}
